import {DynamicPickerDialog} from '@github-ui/filter-picker'

import {getReposItemConfig} from './ItemConfig'
import type {DynamicReposDialogProps, PickerRepository} from './types'

export function DynamicReposPickerDialog<TItem extends PickerRepository>(props: DynamicReposDialogProps<TItem>) {
  const {scope, providers, ...restProps} = props
  const itemConfig = getReposItemConfig(scope)

  return (
    <DynamicPickerDialog<TItem>
      {...restProps}
      title="Filter"
      description="Use a query to select repositories"
      itemConfig={itemConfig}
      providers={providers}
    />
  )
}

try{ DynamicReposPickerDialog.displayName ||= 'DynamicReposPickerDialog' } catch {}